export const PAGE_DECREMENT_ADJUSTMENT = 1;

export const getPage = () => {
  const page = new URLSearchParams(window.location.search).get('page');

  return page ? Number.parseInt(page) - PAGE_DECREMENT_ADJUSTMENT : null;
};

export const scrollToTop = () =>
  window.requestAnimationFrame(() => window.scrollTo(0, 0));

export const scrollToFilters = (delay = 0, isSubCat, isMobile) => {
  setTimeout(() => {
    const isHeaderVisible = window.scrollY < window.innerHeight * 0.5;

    // Case 1 — Normal scroll-to-top when not subcat
    if (!isHeaderVisible && !isSubCat) {
      window.requestAnimationFrame(() =>
        window.scrollTo({ behavior: 'smooth', top: 0 }),
      );

      return;
    }

    // Case 2 — For subcat, scroll just below the #right-content element
    if (isSubCat) {
      const separatorElement = document.querySelector('.separator');

      if (separatorElement) {
        const rect = separatorElement.getBoundingClientRect();
        const absoluteTop = window.scrollY + rect.top;

        // Scroll to just below the element — add a small offset so it’s not flush
        const offset = isMobile ? 20 : 0;
        const targetY = absoluteTop + rect.height + offset;

        window.requestAnimationFrame(() => {
          window.scrollTo({ behavior: 'smooth', top: targetY });
        });
      } else {
        window.requestAnimationFrame(() =>
          window.scrollTo({ behavior: 'smooth', top: isMobile ? 350 : 650 }),
        );
      }
    }
  }, delay);
};
